import * as actions from './actions';
import { AddDialogProps, Dialog } from './types';

export const closeDialog = (type: Dialog) => {
  window.top!.store.dispatch(actions.closeDialog(type));
};

export const closeAllDialogs = () => {
  window.top!.store.dispatch(actions.closeAllDialogs());
};

export const addDialog = <T = Record<string, any>>(type: Dialog, props: AddDialogProps<T>) => {
  window.top!.store.dispatch(actions.addDialog(type, props));

  return () => {
    closeDialog(type);
  };
};
